import {
  type FlexProps,
  type OptionSelectionProps,
  Button,
  Divider,
  Flex,
  FormSelection,
  mergeSx,
} from '@shared/components';
import { useMemo } from 'react';

import { UserAppRoleSelection } from '../../../containers';
import { USER_STATUS_TEXT } from '../../constants';
import { UserStatus } from '../../types';

function getStatusOptions(): OptionSelectionProps[] {
  return (Object.keys(UserStatus) as Array<UserStatus>).map((status) => {
    return { label: USER_STATUS_TEXT[status], value: status };
  });
}

interface FilterUserFormProps extends FlexProps {
  withStatusFilter?: boolean;
  withAppRoleFilter?: boolean;
}

export function FilterUserForm(props: Readonly<FilterUserFormProps>) {
  const { sx, withStatusFilter, withAppRoleFilter, ...restProps } = props;
  const statusOptions = useMemo(() => getStatusOptions(), []);
  return (
    <Flex
      sx={mergeSx(
        (theme) => ({
          flexDirection: 'column',
          width: '100%',
          gap: theme.spacing(4),
          border: '1px solid',
          borderColor: theme.palette.grey[200],
          borderRadius: theme.shape.rounded(2),
          backgroundColor: theme.palette.common.white,
          p: theme.spacing(4),
        }),
        sx,
      )}
      {...restProps}
    >
      <Flex sx={{ gap: 4, alignItems: 'center' }}>
        {withAppRoleFilter ? (
          <UserAppRoleSelection
            name='role'
            label='Role'
            placeholder='Select Role'
            multiple={undefined}
            sx={{ maxWidth: 347 }}
          />
        ) : null}
        {withStatusFilter ? (
          <FormSelection
            label='Status'
            name='status'
            placeholder='Select Status'
            options={statusOptions}
            sx={{ maxWidth: 347, width: '100%' }}
          />
        ) : null}
      </Flex>
      <Divider />
      <Flex sx={{ justifyContent: 'end', gap: (theme) => theme.spacing(2) }}>
        <Button color='secondary' variant='outlined' type='reset'>
          Reset
        </Button>
        <Button type='submit'>Apply</Button>
      </Flex>
    </Flex>
  );
}
